<template>
    <div>
        <div v-if="$loadingRouteData"
             class="container -producer">
            <loader></loader>
        </div>

        <div v-if="!$loadingRouteData"
             class="container -sheet-list">
            <ol class="breadcrumb">
                <li><a v-link="{name: 'home'}">Accueil</a></li>
                <li>Bordereaux</li>
            </ol>

            <div class="heading f -a-center -gutter">
                <h1 class="expand">Bordereaux</h1>

                <div>
                    <a v-link="{name: 'sheet-companies'}"
                       class="btn btn-primary">
                        <i class="glyphicon glyphicon-plus"></i>
                        Saisir un bordereau
                    </a>
                </div>
            </div>

            <div class="filters">
                <div class="row">
                    <div class="col-sm-3">
                        <h3>À partir de</h3>
                        <editable-date :value.sync="dateStart"
                                       :enable-reset="true"
                                       placeholder="Définir..."></editable-date>
                    </div>
                    <div class="col-sm-3">
                        <h3>Jusqu'à</h3>
                        <editable-date :value.sync="dateStop"
                                       :enable-reset="true"
                                       placeholder="Définir..."></editable-date>
                    </div>
                    <div class="col-sm-6">
                        <h3>Actions</h3>

                        <div class="f -gutter-small">
                            <div class="confirm-container">
                                <button class="btn btn-danger"
                                        @click.prevent="confirmFreeze">
                                    <loader :inline="true" v-if="loadingFreeze"></loader>
                                    Geler les bordereaux
                                </button>
                                <div class="popover fade-transition left -confirm"
                                     :class="{'-visible': showConfirmFreeze}">
                                    <div class="arrow"></div>
                                    <h3 class="popover-title">Confirmer&nbsp;?</h3>
                                    <div class="popover-content f -a-center -gutter">
                                        <a @click.prevent="cancelFreeze"
                                           class="btn btn-link">
                                            Annuler
                                        </a>
                                        <a @click.prevent="freeze"
                                           class="btn btn-primary">
                                            Geler
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <a class="btn btn-primary"
                               href="#"
                               @click.prevent="export">
                                <loader :inline="true" v-if="loadingExport"></loader>
                                Exporter
                            </a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <h3>Compagnies</h3>
                        <checkbox-group :value.sync="companies" type="default">
                            <checkbox-btn :value="c.slug"
                                          v-for="c in companiesDb">
                                {{ c.name }}
                            </checkbox-btn>
                        </checkbox-group>
                    </div>
                </div>
            </div>

            <table class="table table-striped -row-links">
                <tr>
                    <th>Date</th>
                    <th>Compagnie</th>
                    <th>Référence</th>
                    <th>État</th>
                </tr>

                <tr v-for="s of sheets">
                    <td><a href="#"
                           v-link="{name: 'sheet-edit', params: {id: s.id}}">
                        {{ s.date | date 'LL' }}
                    </a></td>
                    <td><a href="#"
                           v-link="{name: 'sheet-edit', params: {id: s.id}}">
                        {{ s.company.name }}
                    </a></td>
                    <td><a href="#"
                           v-link="{name: 'sheet-edit', params: {id: s.id}}">
                        {{ s.reference }}
                    </a></td>
                    <td><a href="#"
                           v-link="{name: 'sheet-edit', params: {id: s.id}}">
                        <i class="fa"
                           :class="{'fa-lock': s.frozen, 'fa-unlock': !s.frozen}"></i>
                    </a></td>
                </tr>
            </table>

            <loader v-show="loading" class="bigger-loader"></loader>

            <div class="load-more">
                <a href="#"
                   v-if="hasNext && !loading"
                   v-on:click.prevent="updateList(true)"
                   class="btn btn-default">
                    Charger plus
                </a>
            </div>
        </div>

        <modal :show.sync="showDownloadModal">
            <div class="modal-header"
                 slot="modal-header">
                <h3>Export prêt</h3>
            </div>
            <div class="modal-body"
                 slot="modal-body">
                <div class="export-cta">
                    <a :href="downloadUrl"
                       target="_blank"
                       class="btn btn-link">
                        Télécharger l'export
                    </a>
                </div>
            </div>
            <div class="modal-footer"
                 slot="modal-footer">
                <button class="btn btn-primary"
                        @click.prevent="showDownloadModal = false">
                    Fermer
                </button>
            </div>
        </modal>
    </div>
</template>

<style lang="less"
       scoped>
    @import '~src/style/variables';

    .load-more {
        text-align: center;
    }

    .filters {
        margin: @grid-gutter-width 0;
    }

    .confirm-container {
        position: relative;
    }

    .popover.-confirm {
        display: block;
        position: absolute;
        right: 100%;
        left: auto;
        top: 50%;
        transform: translateY(-50%);
        transition: ease 300ms;
        visibility: hidden;
        opacity: 0;

        &.-visible {
            visibility: visible;
            opacity: 1;
        }
    }

    .export-cta {
        text-align: center;
    }
</style>

<script type="text/ecmascript-6">
    import Loader from '../components/Loader';
    import EditableDate from '../components/editable/EditableDate';
    import CheckboxGroup from 'vue-strap/src/checkboxGroup';
    import CheckboxBtn from 'vue-strap/src/checkboxBtn';
    import Modal from 'vue-strap/src/Modal';
    import {makeUpdateList, tryOr404, asyncAction} from '../utils';
    import {list, freeze, exprt} from '../api/sheets';
    import {getAllCompanies} from '../api/companies';
    import {manager as msgManager} from '../messages';

    export default {
        components: {
            Modal,
            CheckboxGroup,
            CheckboxBtn,
            EditableDate,
            Loader
        },
        data() {
            return {
                loading: false,
                loadingFreeze: false,
                loadingExport: false,
                page: 1,
                hasNext: false,
                sheets: [],
                dateStart: undefined,
                dateStop: undefined,
                showConfirmFreeze: false,
                downloadUrl: undefined,
                showDownloadModal: false,
                companiesDb: [],
                companies: []
            };
        },
        computed: {
            searchQuery() {
                return {
                    start: this.dateStart,
                    stop: this.dateStop,
                    companies: this.companies
                };
            }
        },
        route: {
            data: tryOr404(async function () {
                return {
                    companiesDb: await getAllCompanies()
                };
            })
        },
        methods: {
            updateList: makeUpdateList({
                loading: 'loading',
                page: 'page',
                hasNext: 'hasNext',
                list: 'sheets',
                fetch: async function (page) {
                    return await list(Object.assign({page}, this.searchQuery));
                }
            }),
            freeze: asyncAction('loadingFreeze', async function () {
                this.showConfirmFreeze = false;
                await freeze(this.searchQuery);
                await this.updateList();
                msgManager.push(
                    'Succès.',
                    'Les contrats répondant au filtre ont bien été gelés.',
                    'success'
                );
            }),
            confirmFreeze() {
                this.showConfirmFreeze = true;
            },
            cancelFreeze() {
                this.showConfirmFreeze = false;
            },
            'export': asyncAction('loadingExport', async function () {
                this.downloadUrl = (await exprt(this.searchQuery)).url;
                this.showDownloadModal = true;
            })
        },
        ready() {
            this.updateList();
        },
        watch: {
            searchQuery() {
                this.updateList();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// SheetList.vue?25208818